/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown> }} Plan_Card_Team_NeededInputs */



/**
* | output |
* | --- |
* | "Your team of {seats} needs the Team plan" |
*
* @param {Plan_Card_Team_NeededInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_card_team_needed = /** @type {((inputs: Plan_Card_Team_NeededInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Card_Team_NeededInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihr Team von ${i?.seats} benötigt den Team-Plan`)
	return /** @type {LocalizedString} */ (`Your team of ${i?.seats} needs the Team plan`)
});